import { messageType } from './src-clients-couponCallout.client.types.js';
import { AppliedStatePromoBar, AppliedPromoComponent, AppliedCouponStyledIcon, TextCursorSpan, FlexButton, ExtendedAppliedCouponStyledIcon } from './src-styledComponents-couponComponent.styles.js';
import React from 'react';
import { useScopedBaseConfig } from './src-contexts-CouponCalloutConfig.context.js';
import { useLocalization } from './src-hooks-useLocalizations.js';
import { useCouponDetailsStore } from './src-store-couponDetails.store.js';
import { CouponCodePopover } from './src-components-CouponDisplay-CouponCodePopover.js';

const AppliedCouponDisplay = ({ queryKey }) => {
  const { t } = useLocalization();
  const { pageId } = useScopedBaseConfig();
  const productCouponDetails = useCouponDetailsStore((state) => state.data[pageId]?.couponDetails?.productCouponData?.[queryKey]);
  if (!productCouponDetails) return null;
  const { prices, messageType: messageType$1, couponCode } = productCouponDetails;
  if (messageType$1 === messageType.PRICES && !prices || prices && prices.discountedPrice.taxed >= prices.listPrice.taxed) {
    return null;
  }
  return /* @__PURE__ */ React.createElement(AppliedStatePromoBar, null, /* @__PURE__ */ React.createElement(AppliedPromoComponent, null, /* @__PURE__ */ React.createElement(AppliedCouponStyledIcon, { iconType: "check", size: "16p", alt: t("coupon-callout.check-icon") }), /* @__PURE__ */ React.createElement(TextCursorSpan, null, couponCode), /* @__PURE__ */ React.createElement(
    CouponCodePopover,
    {
      queryKey
    },
    /* @__PURE__ */ React.createElement(FlexButton, { skin: "unstyled" }, /* @__PURE__ */ React.createElement(
      ExtendedAppliedCouponStyledIcon,
      {
        iconType: "info",
        size: "16p",
        alt: t("coupon-callout.info-icon")
      }
    ))
  )));
};

export { AppliedCouponDisplay };
//# sourceMappingURL=src-components-CouponDisplay-AppliedCouponDisplay.js.map
